'use client';

import styled from 'styled-components';

import type { TextAlignType, TextDirectionType } from '@zoomit/editor';
import type { ParagraphElementType } from '@zoomit/editor';
import { Typography } from '@zoomit/zoomit-ds';

interface RenderElementProps {
  children: any;
  element: ParagraphElementType;
  id?: string;
}

const ParagraphElement = (props: RenderElementProps) => {
  const { children, element } = props;

  return (
    <ParagraphBase
      tag="p"
      textAlign={element.annotations?.textAlign}
      textDir={element.annotations?.textDirection}
    >
      {children}
    </ParagraphBase>
  );
};

type ParagraphBaseProps = {
  textAlign: TextAlignType;
  textDir: TextDirectionType;
};

const ParagraphBase = styled(Typography)<ParagraphBaseProps>`
  line-height: 1.88;
  font-size: 1.6rem;
  margin: 0;
  text-align: ${({ textAlign }) => textAlign};
  direction: ${({ textDir }) => textDir};
`;

export default ParagraphElement;
